import auth from '@/router/auth'
import SettingUpdate from '@/components/config-home/Update'
// import Setting2Update from '@/components/config-home/Update2'
import Setting2UpdateV2 from '@/components/config-home/Update2-V2'
import Setting3Update from '@/components/config-home/Update3'
import Setting4Update from '@/components/config-home/Update4'
import Setting5Update from '@/components/config-home/Update5'
import SettingBranchHotUpdate from '@/components/config-home/UpdateBranchHot'
import UpdateHeaderMenuUpdate from '@/components/config-home/UpdateHeaderMenu'
import TestQuizDoc from '@/components/config-home/TestQuizDoc'
import TestUploadVideo from '@/components/config-home/TestUploadVideo'
import SettingStudentRequiredDoct from '@/components/config-home/StudentRequiredDoct'

export default [
  {
    path: '/config-level-facult-default-v2',
    name: 'config-level-facult-default-v2',
    component: Setting2UpdateV2,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/test-quiz-doc',
    name: 'test-quiz-doc',
    component: TestQuizDoc,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/test-upload-video',
    name: 'test-upload-video',
    component: TestUploadVideo,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/config-branch-hot',
    name: 'config-branch-hot',
    component: SettingBranchHotUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/config-header-footer',
    name: 'config-header-footer',
    component: Setting5Update,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/config-header-menu',
    name: 'config-header-menu',
    component: UpdateHeaderMenuUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/config-home-banner',
    name: 'config-home-banner',
    component: Setting4Update,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/config-home-menu',
    name: 'config-home-menu',
    component: SettingUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/config-bank',
    name: 'config-bank',
    component: Setting3Update,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/config-student-required-document',
    name: 'config-student-required-document',
    component: SettingStudentRequiredDoct,
    beforeEnter: auth.requireAuth
  }
  // {
  //   path: '/config-level-facult-default',
  //   name: 'config-level-facult-default',
  //   component: Setting2Update,
  //   beforeEnter: auth.requireAuth
  // }
]



// WEBPACK FOOTER //
// ./src/components/config-home/router.js